import type { I18nShape } from '../i18n';
import type { HotelPricePolicy } from '@skyscanner-internal/landing-pages-shared-types/types-shared/hotels-components/types';

export const PRICE_POLICY = {
  TAXES_NOT_INCLUDED: 'TAXES_NOT_INCLUDED',
  CITY_TAX_NOT_INCLUDED: 'CITY_TAX_NOT_INCLUDED',
  TAXES_INCLUDED: 'TAXES_INCLUDED',
} as const;

export const getPricePolicyText = (
  pricePolicyType: HotelPricePolicy,
  i18n: I18nShape,
) => {
  if (pricePolicyType === PRICE_POLICY.TAXES_INCLUDED) {
    return i18n.translate('OTARates_TaxesIncluded');
  }
  if (pricePolicyType === PRICE_POLICY.TAXES_NOT_INCLUDED) {
    return i18n.translate('dayview_taxes_not_included');
  }
  if (pricePolicyType === PRICE_POLICY.CITY_TAX_NOT_INCLUDED) {
    return i18n.translate('dayview_local_tax_not_included');
  }
  return null;
};
